// These utility functions probably will be changed when switching the content tiles to use
// the pieces approach
import {
  BentoPieceComponentsFragment,
  ContentChunkFragment,
  GenericItemFragment,
  PieceFragment,
  TileFragmentFragment,
  TileFragmentNoGridFragment,
} from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import { ArrayElementType } from '@/integrations/crystallize/types/helpers/ArrayElementType';
import { componentByTypename } from '@/ui/utils/componentByTypename';

export function parseComponents(
  components:
  | TileFragmentFragment['components']
  | GenericItemFragment['components']
  | PieceFragment['components']
  | TileFragmentNoGridFragment['components']
  | BentoPieceComponentsFragment['components'],
) {
  const parsedComponents: any = {};
  components?.forEach((component) => {
    if (!component.content) {
      return;
    }
    parsedComponents[component.id] = component.content;
  });
  return parsedComponents;
}

export function extractComponentFromChunk<
  ComponentArray extends
  | {
    id: string;
    content?: { __typename: string } | null | undefined;
  }[]
  | null
  | undefined,
  ComponentId extends string,
  TypeName extends string &
  (
    NonNullable<ArrayElementType<ComponentArray>['content']> extends {
      __typename: infer PossibleTypenames;
    }
      ? PossibleTypenames
      : never),
>(
  components: ComponentArray,
  id: ComponentId,
  typename: TypeName,
): Extract<ArrayElementType<ComponentArray>['content'], { __typename: TypeName }> | undefined {
  const component = components?.find((c) => c.id === id)?.content;
  if (component?.__typename === typename) {
    return component as Extract<
    ArrayElementType<ComponentArray>['content'],
    { __typename: TypeName }
    >;
  }
  return undefined;
}

export function extractProductInfoFromChunk(chunk: ContentChunkFragment['chunks'][0]) {
  const productContent = extractComponentFromChunk(chunk, 'product', 'ItemRelationsContent')
    ?.items?.[0];
  const product = componentByTypename(productContent, 'Product');
  const title = product?.name;
  const shortDescription = componentByTypename(
    product?.shortDescription?.content,
    'RichTextContent',
  );

  return {
    title,
    shortDescription,
  };
}
